import api from '../api'

export const getEventTypes = async (data: { page: number; page_size: number }) => {
  const res = await api.get('event_types/', { params: data })
  return res.data
}

export const postEventType = async (data: any) => {
  // Use FormData if there's an image
  if (data.image instanceof File) {
    const formData = new FormData()
    formData.append('type', data.type)
    formData.append('display_name', data.display_name)
    formData.append('image', data.image)
    const res = await api.post('event_types/', formData)
    return res.data
  }
  const res = await api.post('event_types/', data)
  return res.data
}

export const putEventType = async ({ type, data }: { type: string; data: any }) => {
  // Use FormData if there's an image
  if (data.image instanceof File) {
    const formData = new FormData()
    formData.append('display_name', data.display_name)
    formData.append('image', data.image)
    const res = await api.put(`event_types/${type}/`, formData)
    return res.data
  }
  const res = await api.put(`event_types/${type}/`, data)
  return res.data
}

export const deleteEventType = async ({ type }: { type: string }) => {
  const res = await api.delete(`event_types/${type}/`)
  return res.data
}

export const postSessionToken = async () => {
  const res = await api.post('user/token/')
  return res.data
}

export const postEventParticipant = async (data: { event_id: string; member_id: string }) => {
  const res = await api.post('admin/events/participants/', data)
  return res.data
}

export const deleteEventParticipant = async (data: { event_id: string; member_id: string }) => {
  const res = await api.delete('admin/events/participants/', { data })
  return res.data
}
